<ion-row class="wrapper-block">
	<ion-col [class.from-menu]="fromMenu" class="wrapper ion-no-padding" size="12">
		<div class="border-line height-block">
			@if (order) {
				<div class="header-block">
					<ion-icon (click)="close()" class="back-icon" src="../../../assets/topgolf/blue-back-arrow.svg"></ion-icon>
					<h1 class="cart-title">{{ 'order.basket' | translate }}</h1>
				</div>
				<div class="ordered-articles">
					@if (hasArticles) {
						<div class="ordered-articles-container">
							<div class="order-list">
								@for (grouped of groupedArticles; track $index; let i = $index) {
									<app-order-list
										(action)="onGroupedAction(grouped.originalIndices, $event)"
										[articleGroup]="grouped.articleGroup"
										[editable]="!loading"
										[order]="order"
										[venue]="venue"
										[promoCategories]="promoCategories"
									></app-order-list>
								}
							</div>
						</div>
					}
					<div [class.card-actions]="!hasArticles">
						@if (!hasArticles) {
							<div class="ion-text-center no-articles">
								<h3>{{ 'order.basket_empty' | translate }}</h3>
							</div>
						}
					</div>
				</div>

				<!-- Applied Promo Code Section -->

				@for (promoCode of order?.promoCodes ?? []; track promoCode) {
					<div class="applied-promo-section">
						<div class="promo-info-row">
							<ion-icon name="pricetags-outline" class="promo-icon"></ion-icon>
							<div class="promo-details">
								<span class="promo-code-text">{{ 'order.promo_code' | translate }}</span>
								@if (promoCode?.name) {
									<span class="promo-code-name">{{ promoCode.name }}</span>
								}
								@if (!promoCode?.name && promoCode) {
									<span class="promo-code-name">{{ promoCode.code }}</span>
								}
							</div>
							<ion-icon name="close-circle" class="remove-promo-icon" (click)="onRemovePromoCode()"></ion-icon>
						</div>
					</div>
				}

				<!-- Recommendation Section -->
				@if (hasArticles && recommendationArticles && recommendationArticles.length > 0) {
					<div class="recommendation-section">
						<h2 class="recommendation-title">{{ 'order.itFitsPerfectly' | translate }}</h2>
						<div class="recommendation-slider-container">
							<div class="recommendation-slider">
								@for (article of recommendationArticles; track article) {
									<div (click)="openModal(article)" class="recommendation-card">
										<div class="recommendation-image">
											@if (article?.assets?.medium) {
												<ion-img [src]="article.assets.medium"></ion-img>
											}
											@if (!article?.assets?.medium) {
												<ion-img src="../../../assets/topgolf/header_logo.svg"></ion-img>
											}
										</div>
										<div class="recommendation-info">
											<h3 class="recommendation-name">{{ article.name | langObservable | async }}</h3>
											<p class="recommendation-price">
												{{ numberToCurrency(getPrice(article, order.type, order.preorder.type), order.currency) }}
											</p>
											@if (article.description) {
												<p class="recommendation-description">
													{{ article.description | langObservable | async }}
												</p>
											}
											<ion-button class="recommendation-btn" fill="outline">
												{{ 'order.add' | translate }}
											</ion-button>
										</div>
									</div>
								}
							</div>
						</div>
					</div>
				}
			}

			<div class="footer-wrapper">
				<div class="footer">
					<div class="footer-total-section">
						<div class="total-price-container">
							<p class="footer-total-text">{{ 'order.total_price' | translate }}</p>
							<p class="products-count">
								({{ getTotalItemCount() }} {{ getTotalItemCount() === 1 ? 'Artikel' : 'Artikel' }})
							</p>
						</div>
						<p class="footer-total-price">{{ totalPriceValue }}</p>
					</div>
				</div>

				<ion-col class="footer-buttons">
					<ion-row>
						@if (loading) {
							<ion-col size="6">
								<ion-spinner class="white center" name="crescent"></ion-spinner>
							</ion-col>
						} @else {
							<ion-col>
								<ion-button
									expand="block"
									class="send-order-button"
									(click)="openCheckoutModal()"
									[disabled]="!isValid || loading"
									fill="solid"
								>
									{{ 'order.pay' | translate }}
								</ion-button>
							</ion-col>
						}
					</ion-row>
				</ion-col>
			</div>
		</div>
	</ion-col>
</ion-row>
